import React, { useEffect } from 'react';
import { Provider, useDispatch, useSelector } from 'react-redux';
import { ThemeProvider, GlobalStyles, CssBaseline } from '@mui/material';
import { RouterProvider } from 'react-router';
import {
  hydrateAuth,
  selectAccessToken,
  selectIsAuthResolved,
  selectUser,
} from '@/slices/auth';
import router from '@/routes';
import { store } from '@/state';
import type { AppDispatch } from '@/state';
import { theme } from '@/theme';
import globalStyles from './globalStyles';

const AuthBootstrap = () => {
  const dispatch = useDispatch<AppDispatch>();
  const accessToken = useSelector(selectAccessToken);
  const user = useSelector(selectUser);
  const isAuthResolved = useSelector(selectIsAuthResolved);

  useEffect(() => {
    if (accessToken && !user && !isAuthResolved) {
      dispatch(hydrateAuth());
    }
  }, [accessToken, dispatch, isAuthResolved, user]);

  return null;
};

const App = () => (
  <Provider store={store}>
    <CssBaseline />
    <GlobalStyles styles={globalStyles} />

    <ThemeProvider theme={theme}>
      <AuthBootstrap />
      <RouterProvider router={router} />
    </ThemeProvider>
  </Provider>
);

export default App;
